// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"470":"652a580a","960":"2af12607"}[chunkId] + ".js";
};